<template>
  <div id="app">
    <section></section>
    <div class="headerContainer">
      <table class="header" id="header">
        <tr>
          <td>
            <span class="rounded">
              <img src="./assets/logo.png">
            </span>
          </td>
          <td>
            <h1>Gwenael Pluchon</h1>
            <h2>Serving statically since 2014 !</h2>
            <Navigation />
          </td>
        </tr>
      </table>
      <div class="mask">
        <transition name="slide-fade">
          <p v-if="$route.params.id">
            <a class="backLink" v-on:click="goToIndex">&lt; Back to index</a>
          </p>
        </transition>
      </div>
    </div>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation';

export default {
  name: 'app',

  methods: {
    goToIndex() {
      this.$router.push('/');
    }
  },

  components: {
    Navigation,
  },
};
</script>

<style>
@font-face{
  font-family    : 'WorkSans';
  src            : url('./assets/fonts/WorkSans-Regular.ttf'); /* IE9 Compat; Modes */
  src            : url('./assets/fonts/WorkSans-Regular.ttf?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/fonts/WorkSans-Regular.woff2') format('woff2'), /* Modern Browsers */ url('./assets/fonts/WorkSans-Regular.woff') format('woff'); /* Modern Browsers */
  font-style     : normal;
  font-weight    : 400;
  text-rendering : optimizeLegibility;
}

html {
  overflow-y: scroll;
  width: 100%;
  overflow-x: hidden;
}

body {
  margin: 0;
}

.headerContainer {
  background: #615F8B;
  color: white;
}

#app {
  font-family: 'Titillium Web', sans-serif;
  margin: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
}

h1, h2, h3, h4, h5 {
  font-family: 'Titillium Web', sans-serif;
}

p {
  font-family: Avenir,Helvetica,Arial,sans-serif;
}

.rounded img {
  border-radius: 50%;
}

.header {
  margin-bottom: 10px;
  display: block;
}
.content, .mask, .header {
  max-width: 800px;
  margin: auto;
}

.contentFull {
  color: #333333;
  margin-left: 4px;
  margin-right: 4px;

}

.post-tag {
  text-decoration: none;
  background: grey;
  border-radius: 12px;
  font-size: 8pt;
  padding: 4px;
  margin: 2px;
  color: black;
}

.backLink {
  font-weight: bold;
  cursor: pointer;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
}

.fade-enter-active, .fade-leave    max-width: 100%;-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.mask {
  height: 19px;
  overflow-y:hidden;
}
.mask p{
  margin: 0;
}
.mask p a{
  position: relative;
}

.post {
  border-top: 1px solid;
  padding-bottom: 1em;
  transition: background 0.2s;
  padding-left: 4px;
  padding-right: 4px;
}

.post:hover {
  background: rgba(127, 127, 127, 0.3);
}

img {
  max-width: 100%;
}
.post p {
  margin-bottom: 0;
}

blockquote {
  margin: 0;
  background: #A5D6A7;
  border-left: 5px solid #81C784;
  font-size: 80%;
  padding: 10px;
}

h3 {
  margin-bottom: 0;
}

.tags {
  margin-bottom: 1em;
}

.rightPanel {
  width: 72px;
  vertical-align: top;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
}

.leftPanel, .rightPanel{
  float: left;
}

.leftPanel {
  width: calc(100% - 92px);
}

.leftPanel h3 {
  margin: 8px;
}

@media screen and (max-width: 800px)
{
  .rightPanel {
    width: 54px;
    padding-right: 2px;
    padding-left: 2px;
  }

  .leftPanel {
    width: calc(100% - 58px);
  }
}

.contentShort {
  margin-top: 6px;
  display: inline-block;
}

pre code {
  font-size: 75%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue